export const i18n = {
  defaultLocale: 'en',
  locales: ['en', 'es'],  //, 'it', 'fr' 'ru', 'zh', 'ja', 'ko', 'de', 'ar'
};
